import { MainTextRow } from '/src/features/live-activity/components/ui';
import { Identity } from '../EventCard';
import { AppLink } from '/src/features/_global/components/AppLink';

export function SurveyResponseEvent({ liveEvent, identifyEvents }) {
  const { survey_id } = liveEvent.data?.attributes ?? {};

  return (
    <div>
      <MainTextRow>
        <Identity id={liveEvent.data?.visitor_id} identifyEvents={identifyEvents} />
        <span className="whitespace-pre">responded to </span>
        <AppLink className="text-link" to={`/addons/${survey_id}`}>
          survey
        </AppLink>
      </MainTextRow>
    </div>
  );
}
